import * as React from 'react';
import { useTheme } from '../../../theming/useTheme';
import { Iframe, IframeProps, IframeThemeProps } from './Iframe';
import { ErrorBoundary } from '../../errorHandling/ErrorBoundary';

const componentConfigurationKey = 'streamable';

export const Streamable: React.FunctionComponent<IframeProps> = props => {
  const themeProps = useTheme<IframeThemeProps>(componentConfigurationKey);
  return <ErrorBoundary><Iframe {...themeProps} {...props} /></ErrorBoundary>;
};
